import React from 'react';
import classNames from 'classnames';
import { domProps } from 'shared/utils/form';

export const readOnlyAttrs = {
  readOnly: true,
  disabled: true,
  title: 'This field is read-only',
};

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer(value) {
    return value;
  },
  toServer(value) {
    const payload = value;
    return payload;
  },
  defaultValue(value) {
    return value;
  },
};

const Input = React.memo(function Input({
  name,
  register,
  displayName,
  required = false,
  readOnly,
  ...props
}) {
  return (
    <input
      id={name}
      className={classNames(
        'w-100 h-input p-2 mb-4 fs-7 fw-normal lh-sm border-0 border-bottom border-input',
        readOnly && 'bg-light text-muted cursor-not-allowed'
      )}
      placeholder={displayName}
      {...register(name, { required })}
      {...(readOnly && readOnlyAttrs)}
      {...domProps(props)}
    />
  );
});

Input.transform = transform;
export default Input;
